import { Component, OnDestroy, OnInit, ViewChild } from '@angular/core';
import { AuthService } from '@app/shared';
import { FormBuilder, FormControl, FormGroup, FormGroupDirective, Validators } from '@angular/forms';
import { ActivatedRoute, Router, Params } from '@angular/router';
import { UserRoles } from '@entity/user-role';

@Component({
  selector: 'app-update-password',
  templateUrl: './update-password.component.html',
  styleUrls: ['./update-password.component.scss']
})
export class UpdatePasswordComponent implements OnInit, OnDestroy {

  loading: boolean;
  message:any = '';
  showMessage: boolean = false;
  resetForm: FormGroup;
  preResetForm: FormGroup;
  roleId: number;
  email: any;
  loginid: any;
  token: any;
  resetData: any;
  resetFormValid: boolean = false;
  resetFlag: boolean = false;
  @ViewChild(FormGroupDirective) formGroupDirective: FormGroupDirective;
  newPasswordCtrl: FormControl;
  confirmPasswordCtrl: FormControl;
  icon: string;
  type: string;
  icon2: string;
  type2: string;
  icon3: string;
  type3: string;

  constructor(private auth: AuthService, private fb: FormBuilder, public router: Router, private route: ActivatedRoute,) {

    this.email = this.route.snapshot.queryParams['email'];
    this.loginid = this.route.snapshot.queryParams['loginid'];
    this.token = this.route.snapshot.queryParams['token'];

    const resetFlag = localStorage.getItem("resetFlag");
    if (resetFlag != "true") {
      this.resetFlag = false;
    }
    else {
      this.resetFlag = true;
    }
  }

  ngOnInit() {

    this.icon = 'fa-eye-slash';
    this.type = 'password';

    this.icon2 = 'fa-eye-slash';
    this.type2 = 'password';

    this.icon3 = 'fa-eye-slash';
    this.type3 = 'password';

    this.newPasswordCtrl = this.fb.control('', Validators.required);
    this.confirmPasswordCtrl = this.fb.control('', Validators.required);

    if (localStorage.getItem("resetFlag") != "true") {
      // this.router.navigate(["/login"]);
      this.resetForm = this.fb.group({
        newPassword: this.newPasswordCtrl,
        confirmPassword: this.confirmPasswordCtrl,
      }, { validator: this.checkPasswords });

      if (sessionStorage.hasOwnProperty('resetData') && (sessionStorage.hasOwnProperty('resetData') != null || sessionStorage.hasOwnProperty('resetData') != undefined)) {
        this.resetFormValid = true;
        if (sessionStorage.hasOwnProperty('token') && (sessionStorage.hasOwnProperty('token') != null || sessionStorage.hasOwnProperty('token') != undefined)) {
          var token = sessionStorage.getItem('token');
          if (this.token == null || this.token == undefined) {
            this.token = this.route.snapshot.queryParams['token'];
          }
          if (this.token != token) {
            this.resetPassword();
          }
        } else {
          this.resetPassword();
        }
      } else {
        this.resetPassword();


        //this.setPasswordPattern();
      }
    }
  }

  iconChange() {
    if (this.icon == 'fa-eye-slash') {
      this.icon = 'fa-eye';
      this.type = 'text';
    } else {
      this.icon = 'fa-eye-slash'
      this.type = 'password';
    }
  }

  iconChange2() {
    if (this.icon2 == 'fa-eye-slash') {
      this.icon2 = 'fa-eye';
      this.type2 = 'text';
    } else {
      this.icon2 = 'fa-eye-slash'
      this.type2 = 'password';
    }
  }

  iconChange3() {
    if (this.icon3 == 'fa-eye-slash') {
      this.icon3 = 'fa-eye';
      this.type3 = 'text';
    } else {
      this.icon3 = 'fa-eye-slash'
      this.type3 = 'password';
    }
  }

  getuserDetails() {
    this.auth.getUser().subscribe((res:any) => {
      this.roleId = res.RoleId;
      this.resetForm.patchValue({
        firstname: res.Firstname,
        lastName: res.Lastname,
        address: res.Address,
        userName: res.LoginId
      });
      this.setPasswordPattern();
    });
  }

  checkPasswords(group: FormGroup) {
    let newPwd = group.get('newPassword').value ? group.get('newPassword').value.trim() : "";
    let confirmPwd = group.get('confirmPassword').value ? group.get('confirmPassword').value.trim() : "";

    let pass = confirmPwd ? confirmPwd.trim().toLowerCase().slice(0, 5) : '';
    let pwd = group.get('confirmPassword').value.trim().toLowerCase().slice(0, 4);// it contains llwr   

    if (localStorage.getItem("resetFlag") == "true") {
      let firstName = group.get('firstname').value != '' ? group.get('firstname').value.trim().toLowerCase().slice(0, 5) : '';
      let lastName = group.get('lastName').value != '' ? group.get('lastName').value.trim().toLowerCase().slice(0, 5) : '';
      let address = group.get('address').value != '' ? group.get('address').value.trim().toLowerCase().slice(0, 5) : '';
      let userName = group.get('userName').value != '' ? group.get('userName').value.trim().toLowerCase().slice(0, 5) : '';
      return newPwd === confirmPwd ? pass && (pwd === "llwr" || pass === userName || pass === firstName || pass === lastName || pass === address) ? { notSameUserInfo: true } : null : { notSame: true };
    } else {
      return newPwd === confirmPwd ? null : { notSame: true };
    }
  }

  resetPassword() {
    let group = {
      'token': [this.token]
    }
    this.preResetForm = this.fb.group(group);
    this.auth.resetUpdatePassword(this.preResetForm.value).then(res => {
      if (!res) {
        this.loading = false;
        this.showMessage = true;

        if (sessionStorage.hasOwnProperty('message') && sessionStorage.hasOwnProperty('message') != null) {
          this.message = sessionStorage.getItem('message');
          sessionStorage.removeItem('message');
        } else {
          this.message = 'Password could not be updated now. please try again later. ';
        }

        setTimeout(() => {
          this.message = '';
          this.showMessage = false;
        }, 7000);
      } else {
        this.loading = false;
        this.resetFormValid = true;
        sessionStorage.setItem('token', this.token)
      }
    });
  }

  onSubmit() {

    this.message = '';
    this.loading = true;
    if (this.resetFormValid == true) {
      this.resetData = JSON.parse(sessionStorage.getItem('resetData'));
      let group = {
        'forgot_token': [this.resetData.forgot_token],
        'ref': [this.resetData.ref],
        'password': [this.resetForm.value.confirmPassword == undefined ? this.resetForm.value.newPassword : this.resetForm.value.confirmPassword]
      }
      let submitForm:any = this.fb.group(group);
      this.auth.updatepassword(submitForm.value).then(res => {
        if (!res) {
          this.loading = false;
          this.showMessage = true;
          if (sessionStorage.hasOwnProperty('message') && sessionStorage.hasOwnProperty('message') != null) {
            this.message = sessionStorage.getItem('message');
            sessionStorage.removeItem('message');

          } else {
            this.message = 'Password could not be updated now. please try again later. ';
          }
          /* setTimeout(() => {
            this.resetForm.setValue({
              confirmPassword: null,
              newPassword: null,
            })
            this.resetForm.markAsPristine();
            this.resetForm.markAsUntouched();
            this.resetForm.clearValidators()


          }, 3000); */
         /*  setTimeout(() => {
            this.message = '';
            this.showMessage = false;
          }, 8000); */
        } else {
          this.loading = false;
          this.showMessage = true;
          if (sessionStorage.hasOwnProperty('message') && sessionStorage.hasOwnProperty('message') != null) {
            this.message = sessionStorage.getItem('message');
            sessionStorage.removeItem('message');
          } else {
            this.message = 'password has been updated successfully';
          }
          setTimeout(() => {
            this.message = '';
            this.showMessage = false;
            sessionStorage.removeItem('resetData')
            this.navigation();
          }, 7000);
        }
      });
    } else {
      return
    }

  }

  pwdMoreThanTwiceValidator(control: FormGroup) {
    var text = control.value.split("");
    let valid = false;
    text.some(function (v, i, a) {
      let array = a.filter(x => x.trim().toLowerCase() == v.trim().toLowerCase());
      if (array != null && array.length > 2)
        valid = true;
    });
    return valid ? { moreThanTwice: true } : null;
  }

  setPasswordPattern() {
    let regex = '^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.*[!#$@%&_-])(?=.{' + this.minLength + ',}).+$';
    this.resetForm.get('newPassword').setValidators([Validators.required, Validators.minLength(parseInt(this.minLength)), Validators.pattern(regex), this.pwdMoreThanTwiceValidator]);
    this.resetForm.get('newPassword').updateValueAndValidity();
  }

  get minLength() {
    return (this.roleId === UserRoles.Admin) || (this.roleId === UserRoles.SuperAdmin) ? "12" : "10";
  }

  navigation() {
    localStorage.clear();
    sessionStorage.clear();
    this.router.navigate(['/login']);
  }

  public ngOnDestroy() {
    sessionStorage.removeItem('token')
  }
}